import React from "react"
import { message, notification } from "antd"
import axios from "axios"
import { withTestModeNote, TestModeNote } from "./testModeNotice"   // tog'a #271
import { translateError } from "./translateError"
import i18n from "../services/i18n"

// tog'a #3410 (2026-10-04): bitta server xatosi IKKI marta chiqardi — quyidagi umumiy ushlagich ko'rsatadi, keyin sahifadagi
// `catch (e) { message.error(apiErrorText(e)) }` (47 joy) yana ko'rsatadi. Endi bir xil matnli xato 2.5 s ichida bir marta chiqadi.
const _xatoKorsatildi: { t: string; at: number }[] = []
export function markErrorShown(...texts: any[]) {
  const now = Date.now()
  for (const x of texts) if (x) _xatoKorsatildi.push({ t: String(x), at: now })
}
const _takror = (txt: string | null) => {
  if (!txt) return false
  const now = Date.now()
  while (_xatoKorsatildi.length && now - _xatoKorsatildi[0].at > 2500) _xatoKorsatildi.shift()
  if (_xatoKorsatildi.some((x) => x.t === txt)) return true
  _xatoKorsatildi.push({ t: txt, at: now })
  return false
}
const _origError = message.error.bind(message)
;(message as any).error = (c: any, ...rest: any[]) => {
  const txt = typeof c === "string" ? c : c && typeof c.content === "string" ? c.content : null
  if (_takror(txt)) { const noop: any = () => {}; noop.then = (r: any) => Promise.resolve(r ? r(true) : true); return noop }
  // tog'a #271: xato ostida «Tizim test rejimida…» yozuvi (takror-filtri matn bo'yicha — shuning uchun o'rash undan KEYIN)
  const isCfg = c && typeof c === "object" && !React.isValidElement(c) && "content" in c
  return (_origError as any)(isCfg ? { ...c, content: withTestModeNote(c.content) } : withTestModeNote(c), ...rest)
}
// tog'a #271: notification.error ham — yozuv + o'sha takror-filtri (umumiy ushlagich message bilan ko'rsatgan matn sahifada qayta chiqmasin)
const _origNotif = notification.error.bind(notification)
notification.error = (args: any) => {
  if (_takror(typeof args?.message === "string" ? args.message : null)) return
  return _origNotif({ ...args, description: args?.description ? withTestModeNote(args.description) : React.createElement(TestModeNote) })
}

const production = process.env.NODE_ENV === 'production'

export const API_URL = process.env.REACT_APP_API_URL || "https://rest.crm.softcity.uz/api/"
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://restcrm.softcity.uz/"
export const WS_URL = process.env.REACT_APP_WS_URL || "wss://api-demo-crm.zendig.uz/graphql"

export const WS_URL2 = process.env.REACT_APP_WS_URL2 || "wss://rest.crm.softcity.uz/socket"
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || "https://minio.ittec.uz/restcrm/"

let isRedirecting = false

const client = axios.create({ baseURL: API_URL })

// s87 (Boshliq 2026-09-09, token 60 daqiqa): JIM YANGILASH. Refresh MUTEX — server har yangilashda refresh-tokenni
// ALMASHTIRADI (rotatsiya), shuning uchun parallel 401'lar bir vaqtda yangilasa biri ikkinchisini o'ldiradi va
// foydalanuvchi chiqib ketadi. Bir vaqtda faqat bitta yangilash; qolganlari o'shani kutadi (mobil ilovadagi naqsh).
let refreshing: Promise<string | null> | null = null
export const refreshAccessToken = (): Promise<string | null> => {
  if (refreshing) return refreshing
  refreshing = (async () => {
    try {
      const access = localStorage.getItem("accessToken") || ""
      const refresh = localStorage.getItem("refreshToken") || ""
      if (!access || !refresh) return null
      const r = await axios.post(API_URL + "AccountAPI/RenewAccessToken", { accessToken: access, refreshToken: refresh }, { timeout: 20000 })
      const data = r.data?.result ?? r.data
      const newAccess = data?.accessToken
      if (!newAccess) return null
      localStorage.setItem("accessToken", newAccess)
      localStorage.setItem("refreshToken", data?.refreshToken ?? refresh)
      // AuthContext/Layout eshitadi (holatni yangilash uchun); SocketContext localStorage'ni o'zi kuzatadi
      try { window.dispatchEvent(new CustomEvent("crm-token-renewed", { detail: { accessToken: newAccess, refreshToken: data?.refreshToken ?? refresh } })) } catch {}
      return newAccess
    } catch {
      return null
    } finally {
      setTimeout(() => { refreshing = null }, 0)   // keyingi 401 uchun yangi urinish ochilsin
    }
  })()
  return refreshing
}
// Serverning ANIQ sabab bilan yopgan sessiyasi — yangilashga urinilmaydi, xabari bilan chiqiladi
const isSessionKilled = (error: any): boolean => {
  const m = String(error?.response?.data?.message || error?.response?.data?.Message || "")
  // s92: «Сессия истекла. Обновите страницу.» (muddati o'tgan access-token) → JIM YANGILASH; faqat refresh ham o'lgan
  // holat («…войдите снова») va aniq yopilgan sessiya («завершена», «заблокирован») → chiqish
  if (/Обновите страницу/i.test(m)) return false
  return /Сессия завершена|заблокирован|войдите снова|входите снова|Требуется авторизация/i.test(m)
}
// Tog'a #342 (avto-yangilanish): ekranni qayta yuklamaydigan yozuvlar
const SHOVQIN = /AccountAPI|RenewAccessToken|Logout|Alerts\/Seen|Notifications?\/(Read|Seen|MarkAll)|Chat|Typing|Presence|Heartbeat|Location|Upload|Minio|Telemetry|ClientLog|AIAgent|AiAgent|Assistant|Push|TwoFactor/i
export const request = ({ ...options }) => {
  let auth = localStorage.getItem("accessToken")
    ? `Bearer ${localStorage.getItem("accessToken")}`
    : ""
  client.defaults.headers.common.Authorization = auth
  client.defaults.headers.common.Accept = "application/json"

  // S18: glavniy admin KUZATUV rejimi — tanlangan tizim ma'lumotini o'qish uchun
  // har so'rovga X-Tenant-View sarlavhasi qo'shiladi. Server tomonda bu FAQAT
  // glavniy admin (TenantId=1 + RoleId=1) uchun kuchga ega (TenantProvider).
  const tenantView = localStorage.getItem("tenantView")
  if (tenantView && Number(tenantView) > 0) {
    client.defaults.headers.common["X-Tenant-View"] = tenantView
  } else {
    delete client.defaults.headers.common["X-Tenant-View"]
  }

  const onSuccess = (response: any) => {
    // Tog'a #342 (katalog #6024, «Авто-обновление»): har muvaffaqiyatli YOZUVDAN keyin ekrandagi ro'yxatlar o'zi yangilanadi —
    // index.tsx «crm-write-ok» ni eshitib faol so'rovlarni qayta oladi (debounce). Chat, bildirishnoma «o'qildi», fayl yuklash,
    // GPS/heartbeat, AI va kirish so'rovlari ekranni qayta yuklamaydi; `noRefresh: true` — chaqiruvchi o'zi hal qiladi.
    try {
      const m = String(options.method || "GET").toUpperCase()
      if (m !== "GET" && !options.noRefresh && !SHOVQIN.test(String(options.url || ""))) window.dispatchEvent(new Event("crm-write-ok"))
    } catch {}
    return response
  }
  const onError = async (error: any) => {
    // s87: muddati o'tgan token (server sabab yozmaydi) → jim yangilab, so'rovni BIR MARTA qayta yuboramiz
    if (error.response?.status === 401 && !options._retried && !isSessionKilled(error)
        && !String(options.url || "").includes("RenewAccessToken") && !String(options.url || "").includes("AccountAPI/Login")) {
      const fresh = await refreshAccessToken()
      if (fresh) {
        const retry = { ...options, _retried: true, headers: { ...(options.headers || {}), Authorization: `Bearer ${fresh}` } }
        return client(retry).then(onSuccess).catch(onError)
      }
    }
    if (error.response?.status === 401) {
      const isLogoutRoute = window.location.pathname.includes("/logout") || window.location.pathname.includes("/login")
      if (!isRedirecting) {
        isRedirecting = true
        if (!isLogoutRoute) {
          const customMsg = error.response?.data?.message || i18n.t("sessionEndedOtherDevice")
          message.error({ content: customMsg, key: "session_expired_toast", duration: 4 })
        }
        localStorage.clear()
        setTimeout(() => {
          window.location.href = "/login"
          isRedirecting = false
        }, 500)
      }
      return Promise.reject(error)
    }

    // Do'konga chiqarish (2026-09-23): `silent: true` — huquq/mavjudlik sinovi (masalan chatdagi «Жалобы» tugmasi).
    // 403/404 bu yerda kutilgan javob: toast ham, huquqlarni qayta so'rash hodisasi ham kerak emas — chaqiruvchi o'zi hal qiladi.
    if (options.silent) return Promise.reject(error)

    // audit F6 (2026-09-04): [ApiController] validatsiya 400 i {title, errors:{...}} shaklida keladi — birinchi xato matni
    let firstValidation: any = null
    try { const errs = error.response?.data?.errors; if (errs && typeof errs === "object") firstValidation = (Object.values(errs) as any[]).flat()[0] } catch {}
    const rawMessage = error.response?.data?.message || error.response?.data?.Message || error.response?.data?.error || firstValidation || error.response?.data?.title || error.message;
    const isForbidden = error.response?.status === 403

    // Egasi (2026-09-01, rol-huquq ideallashtirish): 403 endi QIZIL XATO EMAS.
    // Huquq olib tashlangan foydalanuvchi «Отказано в доступе» ko'rmasligi kerak:
    //  - o'qish (GET) so'rovi: butunlay jim (faqat konsolga, biz debug qilishimiz uchun);
    //  - yozish amali (POST/PUT/DELETE): bitta neytral ogohlantirish — jim muvaffaqiyat
    //    ko'rinishi bundan yomonroq bo'lardi;
    //  - har 403da huquqlar DARHOL qayta so'raladi (AuthContext eshitadi) — menyu
    //    va sahifalar 6 soniya kutmasdan sinxronlanadi.
    if (isForbidden) {
      // eslint-disable-next-line no-console
      console.warn(`[403] ${options.method || "GET"} ${options.url}:`, rawMessage)
      const now = Date.now()
      const last = Number((window as any).__crmPermRefreshAt || 0)
      if (now - last > 3000) {
        ;(window as any).__crmPermRefreshAt = now
        window.dispatchEvent(new Event("crm-refresh-perms"))
      }
      const method = String(options.method || "GET").toUpperCase()
      if (method !== "GET") {
        message.warning({
          content: i18n.t("insufficientRightsUpdated"),
          key: "permission_denied_toast",
          duration: 4,
        })
      }
      return Promise.reject(error)
    }

    // Boshqa xatolar: bitta kalit bilan (parallel so'rovlar ekranni to'ldirmasin)
    const toastKey = rawMessage ? `error_${rawMessage}` : `error_${options.url}`
    // tog'a 1013 (2026-09-04): «Request failed with status code 404» kabi texnik matn o'rniga SABAB:
    // server xabari bo'lsa — u; bo'lmasa status ma'nosi + qaysi so'rov (METHOD url) — foydalanuvchi va biz uchun aniq.
    const status = error.response?.status
    const serverMsg = error.response?.data?.message || error.response?.data?.Message || error.response?.data?.error || firstValidation || error.response?.data?.title
    const isAxiosDefault = !serverMsg && /^Request failed with status code|^Network Error|^timeout of/i.test(String(rawMessage || ""))
    const reqLabel = `${String(options.method || "GET").toUpperCase()} ${options.url || ""}`
    if (isAxiosDefault && options.url && !options.url.includes("Musics") && !options.url.includes("checkSession")) {
      const why = !status ? i18n.t("errNetwork") : status === 404 ? i18n.t("errNotFound") : status === 400 ? i18n.t("errBadRequest")
        : status === 401 ? i18n.t("errUnauthorized") : status >= 500 ? i18n.t("errServer") : i18n.t("errGeneric")
      message.error({ content: `${why}${status ? ` (${status})` : ""} — ${reqLabel}`, key: toastKey, duration: 6 })
    } else if (rawMessage) {
      const friendlyMsg = translateError(rawMessage);
      // tog'a #3927 (2026-10-08, jonli dalil): belgilash AVVAL edi — tarjima matnni o'zgartirmasa (oddiy ruscha server xabari, masalan
      // «Строка 65: артикул … повторяется») yuqoridagi takror-filtri xabarni O'ZI bo'g'ardi va sahifaning onError'i ham — foydalanuvchi
      // hech qanday xato ko'rmasdi (04.10 #3410 dan beri butun web'da). Endi: avval ko'rsatiladi, keyin belgilanadi (sahifa qaytarmasin).
      message.error({ content: friendlyMsg, key: toastKey, duration: 6 });
      markErrorShown(rawMessage, serverMsg)   // #3410: sahifa shu xatoni (xom matnda) qayta ko'rsatmasin
    } else if (options.url && !options.url.includes("Musics") && !options.url.includes("checkSession")) {
      message.error({ content: `${i18n.t("errGeneric")} — ${reqLabel}`, key: toastKey, duration: 4 });
    }
    return Promise.reject(error)
  }
  return client(options).then(onSuccess).catch(onError)
}
